import { Property } from "./property";
import { PropertyViewCard } from './property-view-card';
import { environment } from "../../environments/environment";

export class ProspectTourCard {
    constructor(
        public AddressLine1: string = '',
        public City: string = '',
        public State: string = '',
        public TourDay: number = null,
        public TourMonth: string = '',
        public TourTime: string = '',
        public Back2: string = '',
        public HomeURL: string = '',
        public CardType: string = '',
        public PropertyModel: Property = null,
        public RecordKey: number = null,
        public TourDate: Date = null,
        public YardiKey: string = '',
        public Flip: boolean = true,
        public AddressShort: string = null,
        public Disabled: boolean = false,
        public IsMF: boolean = false,
        public MarketingName: string = '',
        public PropViewCard: PropertyViewCard = new PropertyViewCard(),
    ) { }

    LoadDefaultCard() {
        this.HomeURL = `https://www.${environment.triconDomain}.com`;
        this.CardType = "DefaultCard";
        this.Flip = true;
    }

}
